module.exports = __webpack_public_path__ + "img/chin.41861be4.svg";